export default class MediaVideo {
    constructor(container) {
        this.container = container;
        this.video = container.querySelector('video');
        this.playButton = container.querySelector('.play-btn');
        if (!this.video)
            return;
        this.initEvents();
    }
    initEvents() {
        if (this.playButton) {
            this.playButton.addEventListener('click', () => this.togglePlay());
        }
        this.video.addEventListener('click', () => {
            if (!this.video.paused) {
                this.pause();
            }
        });
        this.video.addEventListener('ended', () => {
            this.showPlayButton();
        });
    }
    togglePlay() {
        if (this.video.paused) {
            this.play();
        }
        else {
            this.pause();
        }
    }
    play() {
        this.video.play();
        this.hidePlayButton();
    }
    pause() {
        this.video.pause();
        this.showPlayButton();
    }
    showPlayButton() {
        if (this.playButton)
            this.playButton.classList.remove('hidden');
    }
    hidePlayButton() {
        if (this.playButton)
            this.playButton.classList.add('hidden');
    }
}
